import { watch } from 'vue';
import { useRouter } from 'vue-router';
import i18n from '@/plugins/i18n';
import { routeTitle, setTabTitle } from '@/utils/navUtils';

let isInitialized = false;

export function useDocumentTitle(): void {
    if (isInitialized) {
        return;
    }
    isInitialized = true;

    const router = useRouter();

    const updateTitle = () => {
        const route = router.currentRoute.value;
        if (route.meta.pageTitle) {
            setTabTitle({ title: routeTitle(route) });
        }
    };

    // Watch locale changes
    watch(
        () => i18n.global.locale.value,
        () => updateTitle(),
    );

    // Watch route changes
    watch(
        () => router.currentRoute.value,
        () => updateTitle(),
        { immediate: true },
    );
}
